export default {
    MENU: {
        HOME: 'Início',
        DOCUMENT: 'Documentação',
        PROFILE: 'Informações pessoais',
        ADVANTAGE_PRODUCTS: 'Produtos com vantagam fiscal',
        OTHER_PRODUCTS: 'Outros produtos',
        LEGAL: 'Aviso legal',
        PRIVACY: 'Política de privacidade',
        COOKIE_MESSAGE: 'Este site usa cookies para melhorar a experiência',
        COMPENSATION: 'A minha compensação',
        FLEXIBLE: 'Produtos de vantagem fiscal',
        DOCUMENTATION: 'Documentação',
        PERSONAL: 'Informações pessoais',
        MY_COMPENATION: 'Minha compensação',
        EXPENSE_MANAGEMENT: 'Gerenciamento de despesas',
        CORPORATE_SOCIAL_RESPONSIBILITY: 'Responsabilidade social corporativa',
        HELLO: 'Olá',
        WELCOME_MESSAGE: 'Bem-vindo ao seu plano de remuneração flexível. Na secção “Documentação” encontrará todas as informações necessárias. Lembre-se que deve primeiro preencher a secção “Informações pessoais”',
        TERMS_AND_CONDITIONS: 'Termos e Condições'
    },
    HEADER: {
        SAVED: 'Poupados',
        PENDING_SAVING: 'Possíveis de poupar',
        LIMIT: 'Limite máximo',
        REACHED: 'Alcançado',
        LANGUAGE: 'Idioma',
        CHECKOUT: 'Tramitar pedido',
        LOGOUT: 'Encerrar sessão',
        HELP: 'Ajuda',
        CONTACT: 'Contacte-nos',
    },
    HOME: {
        MISSING_PROFILE_INFO: 'Informação do utilizador incompleta: Por favor, verifique se preencheu o e-mail/telefone do seu perfil',
        CURRENT_SITUATION: 'Situação',
        NEWS: 'Notícias',
        PRODUCTS_WITH_TAX: 'Produtos com vantagam fiscal',
        ALERTS: 'Alertas',
        CONTRACTED_PRODUCTS: 'Produtos contratados',
        PENDING_SIGNATURE: 'A aguardar assinatura',
        PENDING_PRODUCTS: 'A aguardar contrato',
        SAVING: 'Poupados',
        PENDING_SAVING: 'A aguardar poupança',
        NON_SIMULATED_PRODUCT: 'Não simulado',
        PENDING_SIMULATIONS: 'Simulações Pendentes',
        NO_ACTIVE_ALERTS: 'Não tem alertas',
        PRODUCT: 'Produto',
        Status: 'Estado',
        END_DATE: 'Data final',
        Expiring: 'Data de término',
        Go: 'Ir',
        MISSING_DOCUMENT: 'Falta documentação',
        ATTACH_INVOICE: 'Anexar fatura da mês',
        PENDING_CART: 'A aguardar contrato',
        PENDING_REVIEW: 'A aguardar revisão',
        CONTRACTED: 'Contratado',
        CANCELLED: 'Cancelado',
    },
    LIFE_AXA: {
        FALLCC: 'Morte por qualquer causa',
        FALLA: 'Morte por acidente',
        FALLAC: 'Morte por acidente de trânsito',
        IPAA: 'Incapacidade Permanente Absoluta por Acidente',
        IPAAC: 'Incapacidade Permanente Absoluta por Acidente de Trânsito',
        IPACC: 'Incapacidade Permanente Absoluta por qualquer causa',
        GINV: 'Grande Deficiência',
        MANDATORY: 'Obrigatório',
        MANDATORY_2: 'obrigatório para contratar',
        AGE_LIMIT: 'Não disponível para sua idade',
        CANNOT_EXCEED: 'não pode exceder',
        CANNOT_LESS_FALLA: 'Não pode ser inferior a 35.000 €'
    },
    COMPENSATION: {
        Benefits: 'Benefícios Sociais',
        TotalCompensation: 'Total Compensação',
        TotalSecurityCost: 'Custo da Segurança Social'
    },
    DOCUMENT: {
        Documents: 'Documentos',
        DETAIL_ACTION: 'Detalhe por produto',
        DETAIL: 'Detalhe',
        ID: 'Id',
        YEAR: 'Ano',
        NAME: 'Nome',
        CREATED_BY: 'Criado por',
        CREATED_AT: 'Criado em',
        LAST_MODIFICATION: 'Última alteração',
        Admin: 'Administrador',
        no_documents: 'No há documentos carregados',
        no_products: 'Não tem produtos contratados',
    },
    profile: {
        user_tab: 'Informação do utilizador',
        employee_tab: 'Informações pessoais',
        family_tab: 'Informações familiares',
        office: 'Escritório',
        incorrect_password: 'A senha não cumpre as medidas mínimas de segurança: Deve ter no mínimo 8 caracteres, conter números e letras, pelo menos uma letra maiúscula, minúscula, e sem espaços',
        incorrect_repeat_password: 'A senha não corresponde',
        password_deprecated: 'A senha expirou. Por favor, digite a nova senha',
        collective: 'Coletivo',
        legal_entity: 'Entidade legal',
        email: 'E-mail',
        password: 'Palavra-passe',
        repeat_password: 'Repetir palavra-passe',
        id: 'Cartão de cidadão',
        phone: 'Telemóvel',
        bank: 'Número de conta bancária',
        nationality: 'Nacionalidade',
        birthday: 'Data de nascimento',
        Gender: 'Sexo',
        Male: 'Masculino',
        Female: 'Feminino',
        disability: 'Deficiência',
        No: 'Não',
        Yes: 'Sim',
        marital_status: 'Estado civil',
        Single: 'Solteiro',
        Married: 'Casado',
        Divorced: 'Divorciado',
        Widowed: 'Viuvo',
        Address1: 'Endereço 1',
        Address2: 'Endereço 2',
        City: 'Localidade',
        Country: 'País',
        Province: 'Distrito',
        postal_code: 'Código postal',
        fixed_salary: 'Salário Fixo',
        flexible_bag: 'Mala Flexível',
        variable_salary: 'Salário Variável',
        number_payments: 'Número de pagamentos',
        social_security: 'Número de segurança social',
        employee_number: 'Número de funcionário',
        cost_center: 'Centro de custo',
        renting: 'Aluguer',
        private_use: '% uso privado',
        relationship: 'Parentesco',
        spouse: 'Conjuge',
        child: 'Filho/a',
        domestic_partner: 'Casal em união de facto',
        name: 'Nome',
        surname: 'Apelido',
        first_name: 'Nome',
        last_name: 'Apelido',
        last_name_2: 'Segundo Apelido',
        address: 'Endereço',
        subPolicy: 'Subapólice',
        policy: 'Apólice',
        contribution: 'Contribuição',
        publicResponsibility: 'Responsabilidade pública',
        typeOfStreet: 'Tipo de via',
        houseNumber: 'Número',
        mobilePhonePrefix: 'Prefixo do país para celular',
        birthCountry: 'País de nascimento',
        residenceCountry: 'País de residência',
        investmentBasket: 'Cesta',
        investmentProfile: 'Perfil de investimento',
        contributionDate: 'Data de carregamento da contribuição',
        companyCIF: 'CIF da empresa',
        population: 'População',
        residence: 'Residência',
        complement: 'Complemento',
        top_bag: 'Bolsa superior'
    },
    product_names: {
        'health-insurance': 'Saúde',
        transport: 'Transporte',
        food: 'Comida',
        kindergarten: 'Jardim de infância',
        formation: 'Formação',
        renting: 'Aluguer',
        'life-insurance': 'Vida',
        'life-insurance-axa': 'Vida',
        'saving-plan': 'Poupança',
        gym: 'Ginásio',
        lottery: 'lotaria',
        informative: 'Informativo',
    },
    buttons: {
        accept: 'ACEITAR',
        accept_lower: 'Aceitar',
        consent_lower: 'Entendido',
        close: 'FECHAR',
        add_cart: 'ACRESCENTAR AO CARRINHO',
        update_cart: 'ATUALIZAR O CARRINHO',
        remove_cart: 'ELIMINAR DO CARRINHO',
        update_contract: 'ATUALIZAR CONTRATO',
        reset: 'REINICIAR',
        see_details: 'Aceitar a cláusula de privacidade',
        sign: 'ASSINAR',
        back: 'VOLTAR',
        update: 'ATUALIZAR',
        cancel: 'CANCELAR',
        download: 'DESCARREGAR',
        click_here: 'CLIQUE AQUI',
        back_simulation: 'VOLTAR A SIMULAR',
        next_step: 'CONTRATAR',
        add_child: 'ACRESCENTAR FILHO',
        add_family: 'ACRESCENTAR FAMILIAR',
        select: 'SELECIONAR',
        delete: 'ELIMINAR',
        add_member: 'ACRESCENTAR MEMBRO',
        reset_password: 'Repor palavra-passe',
        forgot_password: 'Esqueceu-se da palavra-passe?',
        back_to_login: 'Voltar ao início',
        change_language: 'mudar',
    },
    calculator: {
        header: 'SIMULADOR POUPANÇA IMPOSTO SOBRE O RENDIMENTO',
        increase_dis_income: 'Aumento líquido disponível',
        equi_salary_increase: 'Aumento salário equivalente',
        not_available:
            'Calculadora não disponível por: Informação de salário incompleta',
        edit_profile: 'Editar informação de salário no perfil dos utilizadores.',
        fixed_salary: 'Salário fixo',
        variable_salary: 'Salário variável',
        flexible_products: 'Produtos flexíveis',
        without_remuneration: 'Sem plano de retribuição flexível',
        with_remuneration: 'Com plano de retribuição flexível',
        non_flexible_products: 'Outros produtos',
        total_gross_salary: 'Total salário bruto',
        social_security: 'Segurança social',
        pit: 'IMPOSTO SOBRE O RENDIMENTO',
        withholding_account: 'Retenção de imposto',
        net_salary: 'Salário líquido',
        net_available_salary: 'Salário líquido disponível',
        employee_bag: 'Saco flexível',
        employee_top_bag: 'Saco produtos top',
        employee_user_bag: 'Saco do utilizador',
        company_bag: 'Saco empresa',
        contribution_company: 'Contrib. empresa',
        available: 'Disponível',
        spent: 'Gasto',
    },
    products: {
        health_insurance: 'Seguro de Saúde',
        saving_insurance: 'Seguro de Poupança',
        unit_linked_4_portfolio: 'Seguro de Poupança Unit Linked 4 Portfólios',
        unit_linked_lifecycle: 'Seguro de Poupança Unit Linked Ciclo de Vida',
        month_text: 'Indique o montante mensal disponível',
        min_amount_text: 'Valor mínimo mensal a contratar',
        max_amount_text: 'Valor máximo mensal disponível a contratar',
        max_available: 'Máximo mensal disponível',
        transport_max_text: 'O limite de despesas é de 1500 € por ano',
        start_date: 'Data de início',
        privative_use: 'Uso privado',
        year: 'Ano',
        years: 'Anos',
        vehicle_value: 'Valor do veículo',
        with_no_tax: 'Percentagem sem IVA',
        with_tax: 'Percentagem com IVA',
        number_tickets: 'Número de tickets',
        price_tickets: 'Preço por ticket',
        death_capital: 'Capital por óbito',
        capital_disability: 'Capital por invalidez (opcional)',
        yearly_price: 'Prémio anual',
        value_less_than_prorated: 'O valor deve ser igual ou superior a {{prorated}} por mês',
        select_children:
            'Por favor, selecione as crianças que gostaria de acrescentar ao jardim-de-infância',
        no_children: 'Não tem filhos menores de 3 anos',
        person: 'Pessoa',
        monthly: 'Mensal',
        yearly: 'Anual',
        main_benefit_error: 'Por favor, verifique primeiro o subsídio principal',
        benefit_error: 'Deve selecionar o subsídio',
        price_over_error: 'Supera o montante disponível',
    },
    contracts: {
        month: 'Mês',
        company: 'Empresa',
        capital_death_case: 'Capital por óbito',
        capital_dis_case: 'Capital por invalidez',
        cancel_text: 'O benefício está cancelado',
        pending_text:
            'O produto está a ser revisto. Iremos informá-lo quando for admitido',
        contract_text: 'Já se inscreveu para receber o subsídio',
        zero_message: 'O montante total é 0',
        min_unreached: 'A quantidade mínima mensal não foi atingida',
        max_unreached: 'A quantidade máxima mensal foi ultrapassada',
        reset_message: 'A configuração foi reiniciada',
        update_confirm_message:
            'Vai alterar os termos de um contrato existente, tem a certeza?" Em caso afirmativo, verifique o seu e-mail para concluir o processo',
        select_start_month: 'selecione o mês inicial',
        inactive_product: 'Você não tem permissão para alugar este produto. Entre em contato com o administrador para ativação.',
        saving_in_progress_error: 'Não pode modificar a seleção enquanto tem uma contratação de poupança em curso. Termine o processo atual primeiro.',
        effective_june: 'O produto será efetivo a partir de 1º de junho',
        effective_december: 'O produto será efetivo a partir de 1º de dezembro',
        saving_plan_cart_pending: 'Não é possível adicionar um novo plano de poupança enquanto tiver um pendente no carrinho. Conclua ou cancele o processo atual.',
        savings_plan_modification: 'Só é possível modificar o plano de poupança entre 11 de abril e 10 de maio (efeito: 1 de junho) ou entre 11 de outubro e 10 de novembro (efeito: 1 de dezembro).'
    },
    cart: {
        data_confirm: 'Confirmação de dados',
        sign_contract: 'Assinatura de contrato',
        step_company: 'Seleção da Empresa',
        step_product: 'Seleção de Produto',
        step_family: 'Seleção de Família',
        basket_selection: 'Seleção de cesta',
        step_months: 'Seleção de meses',
        empty_cart: 'O seu carrinho está vazio',
        agree_message:
            'Ao clicar no passo seguinte, aceita contratar automaticamente',
        terms: `Assine e <b><u>receberá um e-mail com o contrato de novação 
            em anexo</u></b> e a lista de produtos selecionados que terá de aceitar.
              <br />
              <br />
              Para terminar o seu processo de contratação, <b><u>é necessário abrir
              e aceitar as condições do e-mail</u></b>. Lembre-se de o fazer antes do dia&nbsp;
              {{cutOffDate}} para que o produto esteja disponível no dia 1 do mês seguinte.`,
        pending: 'PENDENTE',
        completed: 'CONCLUÍDO',
        download_doc_text: 'Por favor descarregue o documento, preencha-o e assine-o',
        edit_family: 'Editar Informação do Beneficiário',
        name: 'Nome',
        surname: 'Apelido',
        address: 'Endereço',
        zip: 'Código postal',
        contact_person: 'Pessoa de contacto',
        contact_phone: 'Telefono de contacto',
        center_name: 'Nome do centro',
        course: 'Curso',
        cancel_confirm: 'Está prestes a cancelar o contrato. Tem certeza?',
        phone_contact: 'Telefono de contacto',
        attach_invoice: 'Por favor, anexe a fatura',
        same_kindergarten: 'É o mesmo jardim de infância que',
        code_center: 'Código do jardim de infância',
        dontknow: 'Se não sabe, clique aqui',
        edit_profile: 'Editar perfil',
        modality_info_details: 'Informação detalhada',
        modality: 'Modalidade',
        beneficiary_info: 'Informação do beneficiário',
        additional_info: 'Informação adicional',
        total: 'Total',
        total_anual: 'Total Anual',
        total_spent: 'TOTAL GASTO',
        flexible_bag: 'Saco flexível',
        company_bag: 'Saco empresa',
        health_provider_noselect:
            'este fornecedor não pode ser selecionado porque o utilizador já assinou um contrato com outro fornecedor',
        no_info: 'Não são necessárias informações',
        expired_products: 'Tem produtos no carrinho com datas inferiores ao prazo da empresa, retire-os para os poder contratar: ',
        expired_warning: 'CADUCADO! Por favor, retire-o',
        time_left: 'Tempo restante',
        days: 'dia(s)',
        remove_products: 'Retire estes produtos do carrinho antes de adquirir',
        no_permission: 'Já não está autorizado a adquirir este produto',
        payment_frequency: 'Frequência de Pagamento',
        saving_plan_modification_window_error: 'Só é possível modificar o seguro de poupança entre 11 de abril e 10 de maio (efeito: 1 de junho) ou entre 11 de outubro e 10 de novembro (efeito: 1 de dezembro).',
    },
    prices: {
        price: 'Preço',
        discount: 'Desc.',
        total: 'Total'
    },
    countries: {
        AF: 'Afeganistão',
        AL: 'Albânia',
        DE: 'Alemanha',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antártida',
        AG: 'Antígua e Barbuda',
        SA: 'Arábia Saudita',
        DZ: 'Argélia',
        AR: 'Argentina',
        AM: 'Armênia',
        AW: 'Aruba',
        AU: 'Austrália',
        AT: 'Áustria',
        AZ: 'Azerbaijão',
        AN: 'Antilhas Holandesas',
        BS: 'Bahamas',
        BH: 'Bahrein',
        BD: 'Bangladesh',
        BB: 'Barbados',
        BE: 'Bélgica',
        BZ: 'Belize',
        BJ: 'Benin',
        BM: 'Bermudas',
        BY: 'Bielorrússia',
        BO: 'Bolívia',
        BA: 'Bósnia e Herzegovina',
        BW: 'Botsuana',
        BR: 'Brasil',
        BN: 'Brunei',
        BG: 'Bulgária',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        BQ: 'Bonaire, Santo Eustáquio e Saba',
        HM: 'Ilha Heard e Ilhas McDonald',
        BT: 'Butão',
        CV: 'Cabo Verde',
        KH: 'Camboja',
        CM: 'Camarões',
        CA: 'Canadá',
        QA: 'Catar',
        TD: 'Chade',
        CL: 'Chile',
        CN: 'China',
        CY: 'Chipre',
        CO: 'Colômbia',
        KM: 'Comores',
        CG: 'Congo',
        KP: 'Coreia do Norte',
        KR: 'Coreia do Sul',
        CI: 'Costa do Marfim',
        CR: 'Costa Rica',
        HR: 'Croácia',
        CU: 'Cuba',
        CW: 'Curaçao',
        DK: 'Dinamarca',
        DM: 'Dominica',
        EC: 'Equador',
        EG: 'Egito',
        SV: 'El Salvador',
        AE: 'Emirados Árabes Unidos',
        ER: 'Eritreia',
        SK: 'Eslováquia',
        SI: 'Eslovênia',
        ES: 'Espanha',
        US: 'Estados Unidos',
        EE: 'Estônia',
        ET: 'Etiópia',
        PH: 'Filipinas',
        FI: 'Finlândia',
        FJ: 'Fiji',
        FR: 'França',
        GA: 'Gabão',
        GM: 'Gâmbia',
        GE: 'Geórgia',
        GH: 'Gana',
        GI: 'Gibraltar',
        GD: 'Granada',
        GR: 'Grécia',
        GL: 'Groenlândia',
        GP: 'Guadalupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GF: 'Guiana Francesa',
        GG: 'Guernsey',
        GN: 'Guiné',
        GQ: 'Guiné Equatorial',
        GW: 'Guiné-Bissau',
        GY: 'Guiana',
        HT: 'Haiti',
        HN: 'Honduras',
        HK: 'Hong Kong',
        HU: 'Hungria',
        IN: 'Índia',
        ID: 'Indonésia',
        IR: 'Irã',
        IQ: 'Iraque',
        IE: 'Irlanda',
        BV: 'Ilha Bouvet',
        IM: 'Ilha de Man',
        CX: 'Ilha do Natal',
        NF: 'Ilha Norfolk',
        IS: 'Islândia',
        AX: 'Ilhas Åland',
        KY: 'Ilhas Cayman',
        CC: 'Ilhas Cocos',
        CK: 'Ilhas Cook',
        FO: 'Ilhas Faroé',
        GS: 'Ilhas Geórgia do Sul e Sandwich do Sul',
        FK: 'Ilhas Malvinas',
        MP: 'Ilhas Marianas do Norte',
        MH: 'Ilhas Marshall',
        UM: 'Ilhas Menores Distantes dos Estados Unidos',
        PN: 'Ilhas Pitcairn',
        SB: 'Ilhas Salomão',
        TC: 'Ilhas Turks e Caicos',
        VG: 'Ilhas Virgens Britânicas',
        VI: 'Ilhas Virgens Americanas',
        IL: 'Israel',
        IT: 'Itália',
        JM: 'Jamaica',
        JP: 'Japão',
        JE: 'Jersey',
        JO: 'Jordânia',
        KZ: 'Cazaquistão',
        KE: 'Quênia',
        KG: 'Quirguistão',
        KI: 'Kiribati',
        KW: 'Kuwait',
        LA: 'Laos',
        LS: 'Lesoto',
        LV: 'Letônia',
        LB: 'Líbano',
        LR: 'Libéria',
        LY: 'Líbia',
        LI: 'Liechtenstein',
        LT: 'Lituânia',
        LU: 'Luxemburgo',
        MO: 'Macau',
        MK: 'Macedônia do Norte',
        MG: 'Madagascar',
        MY: 'Malásia',
        MW: 'Malawi',
        MV: 'Maldivas',
        ML: 'Mali',
        MT: 'Malta',
        MA: 'Marrocos',
        MQ: 'Martinica',
        MU: 'Maurício',
        MR: 'Mauritânia',
        YT: 'Mayotte',
        MX: 'México',
        FM: 'Micronésia',
        MD: 'Moldávia',
        MC: 'Mônaco',
        MN: 'Mongólia',
        ME: 'Montenegro',
        MS: 'Montserrat',
        MZ: 'Moçambique',
        MM: 'Myanmar',
        NA: 'Namíbia',
        NR: 'Nauru',
        NP: 'Nepal',
        NI: 'Nicarágua',
        NE: 'Níger',
        NG: 'Nigéria',
        NU: 'Niue',
        NO: 'Noruega',
        NC: 'Nova Caledônia',
        NZ: 'Nova Zelândia',
        OM: 'Omã',
        NL: 'Países Baixos',
        PK: 'Paquistão',
        PW: 'Palau',
        PS: 'Palestina',
        PA: 'Panamá',
        PG: 'Papua Nova Guiné',
        PY: 'Paraguai',
        PE: 'Peru',
        PF: 'Polinésia Francesa',
        PL: 'Polônia',
        PT: 'Portugal',
        PR: 'Porto Rico',
        GB: 'Reino Unido',
        CF: 'República Centro-Africana',
        CZ: 'República Tcheca',
        CD: 'República Democrática do Congo',
        DO: 'República Dominicana',
        RE: 'Reunião',
        RW: 'Ruanda',
        RO: 'Romênia',
        RU: 'Rússia',
        EH: 'Saara Ocidental',
        WS: 'Samoa',
        AS: 'Samoa Americana',
        BL: 'São Bartolomeu',
        KN: 'São Cristóvão e Nevis',
        SM: 'San Marino',
        MF: 'São Martinho',
        PM: 'São Pedro e Miquelão',
        VC: 'São Vicente e Granadinas',
        SH: 'Santa Helena, Ascensão e Tristão da Cunha',
        LC: 'Santa Lúcia',
        ST: 'São Tomé e Príncipe',
        SN: 'Senegal',
        RS: 'Sérvia',
        SC: 'Seychelles',
        SL: 'Serra Leoa',
        SG: 'Singapura',
        SX: 'Sint Maarten',
        SY: 'Síria',
        SO: 'Somália',
        LK: 'Sri Lanka',
        SZ: 'Suazilândia',
        ZA: 'África do Sul',
        SD: 'Sudão',
        SS: 'Sudão do Sul',
        SE: 'Suécia',
        CH: 'Suíça',
        SR: 'Suriname',
        SJ: 'Svalbard e Jan Mayen',
        TH: 'Tailândia',
        TW: 'Taiwan',
        TZ: 'Tanzânia',
        TJ: 'Tajiquistão',
        IO: 'Território Britânico do Oceano Índico',
        TF: 'Territórios Franceses do Sul',
        TL: 'Timor-Leste',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinidad e Tobago',
        TN: 'Tunísia',
        TM: 'Turcomenistão',
        TR: 'Turquia',
        TV: 'Tuvalu',
        UA: 'Ucrânia',
        UG: 'Uganda',
        UY: 'Uruguai',
        UZ: 'Uzbequistão',
        VU: 'Vanuatu',
        VA: 'Vaticano',
        VE: 'Venezuela',
        VN: 'Vietnã',
        WF: 'Wallis e Futuna',
        YE: 'Iêmen',
        DJ: 'Djibuti',
        ZM: 'Zâmbia',
        ZW: 'Zimbábue'
    },
    common: {
        select: '-- Selecionar --',  // Note que en portugués es con una 'c'
    }
}